<template>
  <div v-bind:class="stickyObj.Theme">
    <div class="wrap-sticky-icon">
      <i class="el-icon-tickets" @click="StickyToggle()" />
      <i class="el-icon-close" @click="StickyReset()" />
    </div>
    <div
      v-show="stickyObj.visible"
      @mouseover="StickyMouseover"
      @mouseleave="StickyMouseleave"
    >
      <div id="sticky-note" class="sticky-container">
        <i
          v-show="stickyObj.mouseOver"
          class="el-icon-close"
          @click="StickyClose"
        />
        <div class="sticky-outer">
          <div class="drag-area" @mousedown="mousedown">&nbsp;</div>
          <div class="sticky">
            <svg width="0" height="0">
              <defs>
                <clipPath id="stickyClip" clipPathUnits="objectBoundingBox">
                  <path
                    d="M 0 0 Q 0 0.69, 0.03 0.96 0.03 0.96, 1 0.96 Q 0.96 0.69, 0.96 0 0.96 0, 0 0"
                    stroke-linejoin="round"
                    stroke-linecap="square"
                  />
                </clipPath>
              </defs>
            </svg>
            <div class="sticky-content">
              <textarea
                v-model="stickyObj.Note"
                rows="5"
                cols="33"
                placeholder="请勿留存重要信息..."
              ></textarea>
            </div>
          </div>
        </div>
        <span @click="styckyChangeColor">
          <svg-icon icon-class="theme" class="el-icon-magic-stick" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import varCommon from "@/utils/varCommon";
import { mapGetters } from "vuex";

export default {
  created() {
    // window.addEventListener("keydown", (e) => {
    //   this.stickyObj.Code += e.key;
    //   if (e.key === "=") {
    //     this.stickyObj.NoteVisible = !this.stickyObj.NoteVisible;
    //   } else {
    //     this.stickyObj.Code = "";
    //   }
    // });
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      stickyObj: {
        // Code: "",
        visible: false,
        Note: "",
        mouseOver: false,
        Theme: "sticky-theme-blue",
        positionLeft: null,
        positionTop: null,
      },
    };
  },
  mounted() {
    // 获取有储存过的资料
    let stickyObj = localStorage.getItem(`sticky-${this.userInfo.userId}`)
      ? JSON.parse(localStorage.getItem(`sticky-${this.userInfo.userId}`))
      : "";

    if (stickyObj) {
      this.stickyObj = stickyObj;
      document
        .getElementById("sticky-note")
        .setAttribute(
          "style",
          `left: ${stickyObj.positionLeft};top: ${stickyObj.positionTop};`
        );
    }
  },
  methods: {
    // 滑鼠进入
    StickyMouseover() {
      this.stickyObj.mouseOver = true;
    },
    // 滑鼠离开
    StickyMouseleave() {
      this.stickyObj.mouseOver = false;
      this.syncSticky();
    },
    // 切换便签
    StickyToggle() {
      this.stickyObj.visible = !this.stickyObj.visible;
      this.syncSticky();
    },
    // 安全重设
    StickyReset() {
      this.$confirm("是否重新设定便签", "注意", {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          this.stickyObj = {
            visible: true,
            Note: "",
            mouseOver: false,
            Theme: "sticky-theme-blue",
            positionLeft: null,
            positionBottom: null,
          };
          document
            .getElementById("sticky-note")
            .setAttribute("style", `left: 2%;bottom: 2%;`);
          this.syncSticky();
        })
        .catch(() => {});
    },
    // 关闭便签
    StickyClose() {
      if (this.stickyObj) {
        this.stickyObj.visible = false;
      }
      this.syncSticky();
    },
    // 改变主题
    styckyChangeColor() {
      if (this.stickyObj.Theme === "sticky-theme-blue") {
        this.stickyObj.Theme = "sticky-theme-yellow";
      } else {
        this.stickyObj.Theme = "sticky-theme-blue";
      }
      this.syncSticky();
    },
    // 开始抓位置
    mousedown(event) {
      this.selectElement = document.getElementById("sticky-note");
      var div1 = this.selectElement;
      this.selectElement.style.cursor = "move";
      var distanceX = event.clientX - this.selectElement.offsetLeft;
      var distanceY = event.clientY - this.selectElement.offsetTop;
      // alert(distanceX)
      // alert(distanceY)

      document.onmousemove = (ev) => {
        var oevent = ev || event;
        div1.style.left = oevent.clientX - distanceX + "px";
        div1.style.top = oevent.clientY - distanceY + "px";

        this.stickyObj.positionLeft = div1.style.left;
        this.stickyObj.positionTop = div1.style.top;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        div1.style.cursor = "default";
      };
    },
    // 同步资讯到 localStorage
    syncSticky() {
      localStorage.setItem(
        `sticky-${this.userInfo.userId}`,
        JSON.stringify(this.stickyObj)
      );
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.sticky-container {
  width: 270px;
  height: 260px;
  position: fixed;
  bottom: 2%;
  left: 2%;
  z-index: 20000;
  line-height: normal;
}

.sticky {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.sticky:before {
  box-shadow: -2px 2px 15px 0 rgba(0, 0, 0, 0.5);
  background-color: rgba(0, 0, 0, 0.25);
  content: "";
  width: 90%;
  left: 5px;
  height: 83%;
  position: absolute;
  top: 30%;
}

.sticky-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;

  clip-path: url(#stickyClip);
}
.sticky-content textarea {
  border: none;
  outline: 0;
  background-color: transparent;
  width: 100%;
  position: absolute;
  top: 0;
  height: 116%;
  padding: 26px 16px 26px 10px;
}

.sticky:before {
  height: 73%;
  width: 90%;
}
.drag-area {
  cursor: move;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.sticky-outer {
  display: flex;
  padding-top: 92%;
  position: relative;
  width: 100%;
}
.el-icon-close {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 10;
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
}
.el-icon-magic-stick {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
}
.wrap-sticky-icon {
  position: absolute;
  top: 0;
  right: 120px;
  height: 50px;
  .el-icon-tickets {
    font-size: 30px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .el-icon-close {
    color: #ff0000;
    cursor: pointer;
    font-size: 13px;
    z-index: 10;
    font-weight: 600;
    position: absolute;
    top: 6px;
    left: -3px;
  }
}

// 主题蓝
.sticky-theme-blue {
  .el-icon-tickets {
    // 小图示
    color: #00b1ff;
  }
  .sticky-content {
    background: linear-gradient(
      180deg,
      rgba(187, 235, 255, 1) 0%,
      rgba(187, 235, 255, 1) 12%,
      rgba(170, 220, 241, 1) 75%,
      rgba(195, 229, 244, 1) 100%
    );
  }
  .el-icon-magic-stick {
    color: #e18c00;
  }
}
// 主题黄
.sticky-theme-yellow {
  .el-icon-tickets {
    // 小图示
    color: #e18c00;
  }
  .sticky-content {
    background: linear-gradient(
      180deg,
      rgba(248, 236, 117, 1) 0%,
      rgba(248, 237, 117, 1) 12%,
      rgba(250, 210, 117, 1) 75%,
      rgba(250, 200, 117, 1) 100%
    );
  }
  .el-icon-magic-stick {
    color: #00b1ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/StickyNote.vue